import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  width: 100%;
  max-width: 600px;
`

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    background-color: #fee2e2;
    border-radius: 999px;
    padding: 0.75rem;
  }

  h1 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #111827;
  }

  p {
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #4b5563;
  }
`

export const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  max-height: 300px;
  overflow-y: auto;
`

export const ProductCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;

  border: 1px solid #fecaca;
  border-radius: 8px;
  background-color: #fef2f2;
  padding: 1rem;

  img {
    height: 48px;
    width: 48px;
    border-radius: 4px;
    object-fit: cover;
  }

  h2 {
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
  }

  span.translated-name {
    display: block;
    font-size: 0.875rem;
    color: #4b5563;
  }
`

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
`

export const Tag = styled.span`
  border-radius: 4px;
  background-color: #f3f4f6;
  color: #374151;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
`

export const UnavailableTag = styled(Tag)`
  background-color: #fee2e2;
  color: #991b1b;
  font-weight: 500;
`

export const WarningBox = styled.div`
  border-radius: 8px;
  background-color: #fefce8;
  padding: 1rem;

  p {
    font-size: 0.875rem;
    color: #854d0e;
  }
`

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`
